import { PAGE_HOST_KIND } from '~common/enum';

type ApiHosts = {
  rental?: string;
  auth?: string;
  payment?: string;
};

type PageHost = {
  kind: PAGE_HOST_KIND;
  apiHosts: ApiHosts;
};

// Mirrors infra-terraform-aws; change both together:
const BASE_DOMAINS = ['getchargefuze.com', 'getchargefuze.dev'];

const CF_DIRECT_PAGE_LABELS = ['web-app', 'v2'];

const ENV_API_HOSTS: ApiHosts = {
  rental: process.env.REACT_APP_API_ENDPOINT,
  auth: process.env.REACT_APP_AUTH_API_ENDPOINT,
  payment: process.env.REACT_APP_PAYMENT_API_ENDPOINT,
};

const apiHostsUnder = (domain: string): ApiHosts => ({
  rental: `https://rental.${domain}`,
  auth: `https://auth.${domain}`,
  payment: `https://payment.${domain}`,
});

export const resolvePageHost = (rawHostname: string): PageHost => {
  const hostname = rawHostname.replace(/\.$/, '');
  const baseDomain = BASE_DOMAINS.find(
    (domain) => hostname === domain || hostname.endsWith(`.${domain}`),
  );
  if (!baseDomain) {
    return { kind: PAGE_HOST_KIND.LOCAL, apiHosts: ENV_API_HOSTS };
  }

  const label = hostname.slice(0, -(baseDomain.length + 1));
  if (CF_DIRECT_PAGE_LABELS.includes(label)) {
    return {
      kind: PAGE_HOST_KIND.CF_DIRECT,
      apiHosts: apiHostsUnder(baseDomain),
    };
  }
  if (label && !label.includes('.')) {
    return {
      kind: PAGE_HOST_KIND.TENANT,
      apiHosts: apiHostsUnder(`${label}.${baseDomain}`),
    };
  }
  return { kind: PAGE_HOST_KIND.UNKNOWN, apiHosts: {} };
};
